<template>
  <div>

    <div class="relativeNav" v-show="!show.navShow" style="width: 100%;position: absolute;">
      <div class="topBox w1300" >
        <ul>
          <li @click="linkDownload('https://m.supaytechnology.com/login')">登录</li>
          <li @click="navClick(8,'/zh-hans/developers')" :class="act.navIndex===8 ? 'act active' : ''">开发</li>
          <li  @click="switchLang">
            <span class="iconImg"><img src="../../../assets/icon/langue_icon.png"/></span>
            <span class="text">EN</span>
          </li>
        </ul>
      </div>
      <div class="navBox w1300"  >
        <div class="logos" @click="navClick(1,'/zh-hans')"><img src="../../../assets/icon/nb__about@2x.png"/></div>
        <div class="rightBox" :class="act.navIndex===7 ? 'act' : ''" @click="navClick(7,'/zh-hans/contact')">联系我们</div>
        <ul class="rightNav">
          <li :class="act.navIndex===6 ? 'act' : ''" @click="navClick(6,'/zh-hans/app')">App</li>
          <li :class="act.navIndex===5 ? 'act' : ''" @click="navClick(5,'/zh-hans/partners')">合作伙伴</li>
          <li :class="act.navIndex===4 ? 'act' : ''" @click="navClick(4,'/zh-hans/services')">市场服务</li>
          <li :class="act.navIndex===3 ? 'act' : ''" @mouseenter="navEnter()" @mouseleave="navLeave()">
            <span style="width: 100%;height: 100%;" @click="mm()">支付解决方案</span>
            <img class="navIcon" src="../../../assets/icon/nav_icon.png"/>
            <div class="nav2" v-show="seen">
              <ul>
                <li @click="navClick(3,'/zh-hans/instorepayment')">线下支付</li>
                <li @click="navClick(3,'/zh-hans/onlinepayment')">线上支付</li>
              </ul>
            </div>
          </li>
          <li :class="act.navIndex===2 ? 'act' : ''" @click="navClick(2,'/zh-hans/aboutus')">关于我们</li>
          <li :class="act.navIndex===1 ? 'act' : ''" @click="navClick(1,'/zh-hans')">首页</li>
        </ul>
      </div>
    </div>


    <div  class="fixedNav animated" :class="show.navShow ? 'fadeInDown showBox' : 'fadeOutUp hideBox'">
      <div class="contentW navBox"  style="overflow: visible;">
        <div class="logos animated" :class="show.navShow ? 'fadeIn' : 'hideBox'" @click="navClick(1,'/zh-hans')"><img src="../../../assets/icon/logo31.png"/></div>
        <!--<div class="logos" :class="show.navShow ? 'logos1' : 'logos2'"  @click="navClick(1,'/')"><img src="../../../assets/icon/logo3.png"/></div>-->
        <div class="rightBox" :class="act.navIndex===7 ? 'act' : ''" @click="navClick(7,'/zh-hans/contact')">联系我们</div>
        <ul class="rightNav">
          <li :class="act.navIndex===6 ? 'act' : ''" @click="navClick(6,'/zh-hans/app')">App</li>
          <li :class="act.navIndex===5 ? 'act' : ''" @click="navClick(5,'/zh-hans/partners')">合作伙伴</li>
          <li :class="act.navIndex===4 ? 'act' : ''" @click="navClick(4,'/zh-hans/services')">市场服务</li>
          <li :class="act.navIndex===3 ? 'act' : ''" @mouseenter="navEnter()" @mouseleave="navLeave()">
            <span style="width: 100%;height: 100%;" @click="mm()">支付解决方案</span>
            <img class="navIcon" src="../../../assets/icon/nav_icon.png"/>
            <div class="nav2" v-show="seen">
              <ul>
                <li @click="navClick(3,'/zh-hans/instorepayment')">线下支付</li>
                <li @click="navClick(3,'/zh-hans/onlinepayment')">线上支付</li>
              </ul>
            </div>
          </li>
          <li :class="act.navIndex===2 ? 'act' : ''" @click="navClick(2,'/zh-hans/aboutus')">关于我们</li>
          <li :class="act.navIndex===1 ? 'act' : ''" @click="navClick(1,'/zh-hans')">首页</li>
        </ul>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: "topNav",
    // props: ['navIndex1'],
    data(){
      return {
        act:{
          navIndex:1,
        },
        show:{
          navShow:false,
        },
        seen:false,
      }
    },
    mounted () {
      var pages=this.$route.name;
      console.log(pages)
      if(pages === "homeCn"){
        this.act.navIndex=1;
      }else if(pages === "aboutUsCn"){
        this.act.navIndex=2;
      }else if(pages === "PaymentInstoreCn" || pages === "PaymentOnlineCn"){
        this.act.navIndex=3;
      }else if(pages === "servicesCn"){
        this.act.navIndex=4;
      }else if(pages === "ourAppCn"){
        this.act.navIndex=6;
      }else if(pages === "PartnersCn"){
        this.act.navIndex=5;
      }else if(pages === "applyCn"){
        this.act.navIndex=7;
      }else if(pages === "DevelopersCn"){
          this.act.navIndex=8;
        }

      window.addEventListener('scroll', this.handleScroll)

    },
    methods:{
      //打开新连接
      linkDownload (url) {
        window.open(url,'_blank') // 新窗口打开外链接
      },

      mm(){
        this.seen = true;
      },

      //鼠标滑动动画
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if(scrollTop>115){
          this.show.navShow=true;
        }else{
          this.show.navShow=false;
        }

      },

      //  点击导航
      navClick(index,url){
        this.act.navIndex=index;
        this.$router.push(url);
      },
      switchLang(){
        window.sessionStorage.setItem('lang', 'en-us')
        this.act.navIndex = 1
        this.$router.push('/')
      },

      navEnter(){
        this.seen = true;
      },
      navLeave(){
        this.seen = false;
      }
    }
  }
</script>

<style scoped>



  .topBox{height: 30px;margin: auto;}
  .topBox>ul{float: right;}
  .topBox .active{color: #fff;transition: all 0.5s ease-in-out;}
  .topBox>ul>li{list-style: none;float: right;font-family: PingFangMedium; height: 30px;line-height: 30px; width: 6rem;border-left: 1px solid rgba(255,255,255,0.2); font-size:14px;color: #9c9ea1;text-align: center;cursor: pointer;}
  .topBox>ul>li:first-of-type{border-right: 1px solid rgba(255,255,255,0.2);}
  .topBox>ul>li:hover{color: #fff;transition: all 0.5s ease-in-out;}
  .topBox>ul>li>span{float: left;}
  .topBox>ul>li .iconImg{float: left;margin-top: 0.25rem;margin-left: 1rem;width: 1rem;margin-right: 0.3rem;}
  .topBox>ul>li .iconImg>img{width: 1rem;cursor: pointer;}
  .navBox{height:83px;border-bottom: 1px solid rgba(255,255,255,0.2);margin: auto;border-top: 1px solid rgba(255,255,255,0.2);position: relative;}
  .navBox .logos{float: left;width: 162px;height: 100%;display: flex;align-items: center;margin-left: 1px;cursor: pointer;}
  .navBox .logos>img{width: 100%;align-items: center;}
  .navBox .rightBox{float: right;width: 7rem;height: 2.5rem;line-height: 2.5rem;font-family: PingFangMedium; font-size: 15px; text-align: center; border: 1px solid rgba(255,255,255,0.2);color: #9c9ea1;cursor: pointer;margin-top: 1.25rem;margin-bottom: 1.25rem;margin-left: 13.5px;}
  .navBox .rightBox:hover{
    color: #fff;
    border-color: #fff;
    transition: all 0.5s ease-in-out;
  }
  .navBox .rightBox.act{color: #fff;border-color: #fff;}
  .navBox .rightNav{float: right;height: 100%;}
  .navBox .rightNav>li{float: right;list-style: none;height: 100%; color: #9c9ea1;display: flex;align-items: center; line-height: 83px;font-size: 15px;padding:0 13.5px;cursor: pointer;position: relative;font-family: PingFangMedium;}
  .navBox .rightNav>li.act{color: #fff;border-bottom: 0.1rem solid #fff;box-sizing: border-box;}
  .navBox .rightNav>li:hover{color: #fff;transition: all 0.5s ease-in-out;}
  .navBox .rightNav>li .navIcon{float: right;margin-left: 10px;align-items: center;}
  .navBox .rightNav>li .nav2{width: calc(100% - 1rem);height: 83px;background-color: #fff;padding: 0.5rem;position: absolute;bottom: -6rem;left:0;margin-bottom: -2px;}
  .navBox .rightNav>li .nav2>ul>li{list-style: none;width: 100%;height: 2.5rem;line-height: 2.5rem; border-top: 1px solid #dddddd;color: rgba(0,0,0,0.3);font-size:15px;text-align: center;}
  .navBox .rightNav>li .nav2>ul>li:first-of-type{border-top: 0;}
  .navBox .rightNav>li .nav2>ul>li:hover{color: #000;}


  .fixedNav{background-color:#fff;position: fixed;width: 100%;z-index: 999;box-shadow:0px 1px 20px 5px rgba(0,0,0,0.3);height: 83px;  }
  .fixedNav .navBox{border-bottom: 1px solid rgba(255,255,255,0);border-top: 1px solid rgba(255,255,255,0);}
  .fixedNav .navBox .rightNav>li{color: rgba(0,0,0,0.3);}
  .fixedNav .navBox .rightNav>li.act{color: #000;border-bottom: 0.1rem solid #2d9ad7;box-sizing: border-box;}
  .fixedNav .navBox .rightNav>li:hover{color: #000;transition: all 0.5s ease-in-out;}
  .fixedNav .navBox .logos{opacity: 0;float: left;width: 205px;height: 100%;display: flex;align-items: center;margin-left: 10px;}
  .fixedNav .navBox .logos.logos1{opacity: 1;transition: all 5s ease-in-out;}
  .fixedNav .navBox .logos.logos2{opacity: 0;transition: all 5s ease-in-out;}
  .fixedNav .navBox .rightBox{border: 1px solid rgba(0,0,0,0.3);color:rgba(0,0,0,0.3); }
  .fixedNav .navBox .rightBox:hover{color: #000;border-color: #000;}
  .fixedNav .navBox .rightBox.act{color: #000;border-color: #000;}






  .hideBox{display: none;}
  .showBox{display: block;}


  @media screen and (min-width: 1600px) {
    .w1300 {
      width:1300px;
    }
  }

  @media screen and (max-width: 1600px) {
    .w1300 {
      width:1100px;
    }
  }



  /*.w1300{width: 1300px;}*/
  /*.w1100{width: 1100px;}*/


</style>
